import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, FormControl, InputLabel, Select, MenuItem, Checkbox } from '@mui/material';
import Swal from 'sweetalert2';
import { broker, compound, featuress, placetype, unit, unittypess, owners, updateunit } from '../../../components/Apis';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { render } from '@testing-library/react';

const Editunit = ({ open, onClose, unitId , rendr }) => {
  const [features, setfeatures] = useState([])
  const [unittypes, setunittypes] = useState([])
  const [compounds, setcompounds] = useState([])
  const [brokers, setbrokers] = useState([])
  console.log(brokers)
  const [placetypes, setplacetypes] = useState([])
  const [owner, setowner] = useState([])

  const [EditItem, setEditItem] = useState({
    id: "",
    name: '',
    images: [],
    contract: null,
    documents: null,
    description: null,
    available_from: null,
    available_to: null,
    off_days: null,
    price: "",
    lat: "",
    lng: "",
    adults: "",
    children: "",
    pets: "",
    bedrooms: "",
    bed: "",
    bathrooms: "",
    beach_passes: "",
    unit_type_id: "",
    features_id: [],
    place_type_id: "",
    compound_id: "",
    owner_id: "",
    check_in: "",
    check_out: "",
    status: "",
    fees: "",
    deposit: "",
    insurance: "",
    maintenance: "",
    broker: "",
    broker_id: "",
    cancellation: [],
    edit: "",
    note: ""
  });
  console.log(EditItem)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const [files, setFiles] = useState({
    images: [],
    contract: null,
    documents: null,
  });

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: name === "images" ? [...selectedFiles] : selectedFiles[0],
    }));
  };


  const handleDateChange = (field, date) => {
    setEditItem((prev) => ({
      ...prev,
      [field]: dayjs(date).format('YYYY-MM-DD'),
    }));
  };

  const handleChangee = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd'); // Format the selected date
    console.log(formattedDate);

    // Update the off_days array
    setEditItem((prevState) => {
      // Ensure off_days is an array if it's null
      const updatedOffDays = Array.isArray(prevState.off_days)
        ? prevState.off_days.includes(formattedDate)
          ? prevState.off_days
          : [...prevState.off_days, formattedDate]
        : [formattedDate]; // Initialize as array if it's null

      return {
        ...prevState,
        off_days: updatedOffDays, // Store the updated off_days array
      };
    });
  };

  const handleChanges = (value) => {
    if (value === undefined) return; // التحقق من القيم قبل استخدامها

    // تحويل القيم النصية إلى القيم الرقمية
    const updatedValue = value === "Active" ? "1" : value === "InActive" ? "0" : value;
    console.log(updatedValue)

    setEditItem((prev) => ({
      ...prev,
      edit: updatedValue, // تحديث الحالة بالقيمة المحوّلة
    }));
  };
  const fetchUnit = async () => {
    try {
      const response = await unit(unitId);
      console.log(response)
      console.log(response)
      setEditItem({
        name: response.name || '',
        id: response.id,
        images: [],
        description: response.description || null,
        available_from: response.available_from ? dayjs(response.available_from).format('YYYY-MM-DD') : null,
        available_to: response.available_to ? dayjs(response.available_to).format('YYYY-MM-DD') : null,
        features_id: response.features_id || null,
        unit_type_id: response.unit_type_id || null,
        compound_id: response.compound_id || null,
        place_type_id: response.place_type_id || null,
        check_in: response.check_in || null,
        check_out: response.check_out || null,
        lat: response.lat || "0.00000000",
        lng: response.lng || "0.00000000",
        adults: response.adults || "0",
        children: response.children || "0",
        pets: response.pets || "0",
        bedrooms: response.bedrooms || "0",
        bed: response.bed || "0",
        bathrooms: response.bathrooms || "0",
        beach_passes: response.beach_passes || "0",
        note: response.note || "",

      });
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchfeatures = async () => {

    try {


      const response = await featuress();
      console.log(response)
      setfeatures(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    } finally {
    }
  };
  const fetchunittypes = async () => {

    try {


      const response = await unittypess();
      setunittypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };

  const fetchcompound = async () => {

    try {
      const response = await compound();
      console.log(response)
      setcompounds(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchplacetypes = async () => {

    try {


      const response = await placetype();
      console.log(response)
      setplacetypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };

  useEffect(() => {
    if (unitId) {
      fetchUnit();
      fetchplacetypes()
      fetchcompound()
      fetchunittypes()
      fetchfeatures()
    }
  }, [unitId]);

  const HandleSubmit = async () => {
    const formData = new FormData();
    formData.append("name", EditItem.name);
    formData.append("description", EditItem.description);
    formData.append("available_from", EditItem.available_from);
    formData.append("available_to", EditItem.available_to);
    formData.append("lat", EditItem.lat);
    formData.append("lng", EditItem.lng);
    formData.append("adults", EditItem.adults);
    formData.append("children", EditItem.children);
    formData.append("pets", EditItem.pets);
    formData.append("bedrooms", EditItem.bedrooms);
    formData.append("bed", EditItem.bed);
    formData.append("bathrooms", EditItem.bathrooms);
    formData.append("beach_passes", EditItem.beach_passes);
    formData.append("unit_type_id", EditItem.unit_type_id);
    formData.append("place_type_id", EditItem.place_type_id);
    formData.append("compound_id", EditItem.compound_id);
    formData.append("note", EditItem.note);
    formData.append("check_in", EditItem.check_in);
    formData.append("check_out", EditItem.check_out);



    if (EditItem.features_id) {
      EditItem.features_id.forEach((day, index) => {
        formData.append(`features_id[${index}]`, day);
      });
    }



    if (files.images.length > 0) {
      files.images.forEach((file) => {
        formData.append("images[]", file);
      })
    }


    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }


    const res = await updateunit(formData, EditItem.id)

    if (res.message === "Request failed with status code 413") {
      Swal.fire("Please upload a smaller image and pdf")
      onClose()
    }
    if (res.message === "Unit Updated Successfully") {
      Swal.fire("Unit Updated Successfully")
      rendr()
      onClose()
    }
    // window.location.reload()


  }
  const convertDatesToDateObjects = (dates) => {
    return dates
      .map(date => dayjs(date).isValid() ? new Date(date) : null)
      .filter(Boolean);
  };


  return (
    <Dialog open={open} dir="ltr" onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Unit</DialogTitle>
      <DialogContent>
        <TextField
          name="name"
          label="Name"
          type="text"
          value={EditItem.name || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          name="description"
          label="Description"
          type="text"
          value={EditItem.description || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          name="note"
          label="Note"
          type="text"
          value={EditItem.note || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ my: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Available From
            </Typography>
            <DatePicker
              value={EditItem.available_from ? dayjs(EditItem.available_from) : null}
              onChange={(date) => handleDateChange('available_from', date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  inputProps: {
                    dir: "ltr"
                  }
                },
                popper: {
                  sx: {
                    direction: "ltr",
                    '& .MuiPickersCalendarHeader-root': {
                      direction: "ltr"
                    },
                    '& .MuiPickersCalendar-root': {
                      direction: "ltr"
                    }
                  }
                }
              }}
            />
          </Box>

          <Box sx={{ my: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Available To
            </Typography>
            <DatePicker
              value={EditItem.available_to ? dayjs(EditItem.available_to) : null}
              onChange={(date) => handleDateChange('available_to', date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  inputProps: {
                    dir: "ltr"
                  }
                },
                popper: {
                  sx: {
                    direction: "ltr",
                    '& .MuiPickersCalendarHeader-root': {
                      direction: "ltr"
                    },
                    '& .MuiPickersCalendar-root': {
                      direction: "ltr"
                    }
                  }
                }
              }}
            />
          </Box>


        </LocalizationProvider>

        <Typography variant="body2" sx={{ marginBottom: '8px' }}>
          Upload Images
        </Typography>
        <Box mb={1} sx={{ border: '1px solid #ccc', borderRadius: '4px', padding: '8px' }}>
          <input
            type="file"
            name="images"
            accept="image/*"
            multiple
            onChange={handleFileChange}
          />
        </Box>
        {EditItem.images.length > 0 && (
          <Typography variant="body2" sx={{ marginTop: '8px' }}>
            Selected Images: {EditItem.images.length}
          </Typography>
        )}


        <FormControl fullWidth margin="normal">
          <InputLabel>Features</InputLabel>
          <Select
            name="features_id"
            value={EditItem.features_id || []} // القيمة الحالية من الحالة
            onChange={(e) => {
              const value = e.target.value.map(String); // تحويل القيم إلى نصوص
              setEditItem((prev) => ({
                ...prev,
                features_id: value, // تحديث المصفوفة بالقيم النصية
              }));
            }}
            multiple
            renderValue={(selected) =>
              selected
                .map((id) => features.find((feature) => feature.id.toString() === id)?.feature) // عرض أسماء المزايا
                .join(', ')
            }
          >
            {features.map((feature) => (
              <MenuItem key={feature.id} value={feature.id.toString()}> {/* تخزين القيمة كنص */}
                <Checkbox
                  checked={EditItem.features_id.includes(feature.id.toString())} // التحقق من النصوص
                  onChange={(e) => {
                    e.stopPropagation(); // منع فتح القائمة عند النقر على الـ Checkbox
                    setEditItem((prev) => {
                      const isSelected = prev.features_id.includes(feature.id.toString());
                      return {
                        ...prev,
                        features_id: isSelected
                          ? prev.features_id.filter((id) => id !== feature.id.toString()) // إزالة العنصر كنص
                          : [...prev.features_id, feature.id.toString()], // إضافة العنصر كنص
                      };
                    });
                  }}
                />
                {feature.feature}
              </MenuItem>
            ))}
          </Select>

        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>Unit Type</InputLabel>
          <Select
            name="compound_id"
            value={EditItem.compound_id} // القيمة المختارة للـ owner_id
            onChange={handleChange} // عند تغيير الاختيار
          >
            {compounds.map((type, index) => (
              <MenuItem key={index} value={type.id}> {/* هنا القيمة هي owner_id */}
                {type.compound} {/* وعرض owner_name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>Place Type</InputLabel>
          <Select
            name="place_type_id"
            value={EditItem.place_type_id} // القيمة المختارة للـ owner_id
            onChange={handleChange} // عند تغيير الاختيار
          >
            {placetypes.map((type, index) => (
              <MenuItem key={index} value={type.id}> {/* هنا القيمة هي owner_id */}
                {type.place_type} {/* وعرض owner_name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>



        <TextField
          sx={{ my: 2 }}
          label="Check In"
          type="time"
          name="check_in"
          value={EditItem.check_in} // القيمة الحالية للوقت
          onChange={handleChange} // عند التغيير
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 1, // خطوة واحدة (ثانية واحدة)
          }}
        />
        <TextField
          sx={{ my: 2 }}
          label="Check Out"
          type="time"
          name="check_out"
          value={EditItem.check_out} // القيمة الحالية للوقت
          onChange={handleChange} // عند التغيير
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 1, // خطوة واحدة (ثانية واحدة)
          }}
        />


        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center" }}>
          <TextField
            name="lat"
            label="lat"
            type="text"
            sx={{ width: "50%" }} value={EditItem.lat || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="lng"
            label="lng"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.lng || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center" }}>
          <TextField
            name="adults"
            label="adults"
            type="text"
            sx={{ width: "50%" }} value={EditItem.adults || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="children"
            label="children"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.children || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center" }}>
          <TextField
            name="pets"
            label="pets"
            type="text"
            sx={{ width: "50%" }} value={EditItem.pets || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="bedrooms"
            label="bedrooms"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.bedrooms || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center" }}>
          <TextField
            name="bed"
            label="bed"
            type="text"
            sx={{ width: "50%" }} value={EditItem.bed || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="bathrooms"
            label="bathrooms"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.bathrooms || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center" }}>
          <TextField
            name="beach_passes"
            label="beach_passes"
            type="text"
            sx={{ width: "50%" }} value={EditItem.beach_passes || ''}
            onChange={handleChange}
            margin="normal"
          />

        </div>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}
          sx={{
            backgroundColor: "#a0553a",
            color: "white",
            "&:hover": {
              backgroundColor: "#a0553a",
              color: "white",
            },
          }}
        >Cancel</Button>
        <Button onClick={HandleSubmit} variant="contained"
          sx={{
            backgroundColor: "#a0553a",
            color: "white",
            "&:hover": {
              backgroundColor: "#a0553a",
              color: "white",
            },
          }}
        >Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default Editunit;

